import { AtomIcon, DnaIcon, Flower2Icon, MicroscopeIcon, PipetteIcon, TreeDeciduousIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'The Molecule of Life: DNA, Genes, Chromosomes & Replication',
    summary: 'A visual teaching reference to the molecule that stores, packs and copies the instructions of every living thing.',
    icon: DnaIcon,
  },
  {
    number: '02',
    title: "Mendel's Laws & Patterns of Inheritance",
    summary: 'A visual teaching reference to how traits pass from parents to offspring — and how to predict them.',
    icon: Flower2Icon,
  },
  {
    number: '03',
    title: 'Gene Expression: From DNA to Protein & How Genes Are Controlled',
    summary: 'A visual teaching reference to how cells read their genes, build proteins and decide which genes to switch on.',
    icon: AtomIcon,
  },
  {
    number: '04',
    title: 'Mutations, Genetic Variation & Human Genetics',
    summary: 'A visual teaching reference to how DNA changes, why every person is unique and what genes can — and cannot — tell us.',
    icon: MicroscopeIcon,
  },
  {
    number: '05',
    title: 'Biotechnology & Genetic Engineering: From PCR to CRISPR',
    summary: 'A visual teaching reference to how scientists cut, copy, read and edit DNA.',
    icon: PipetteIcon,
  },
  {
    number: '06',
    title: 'Population Genetics, Evolution & Bioethics',
    summary: 'A visual teaching reference to how genes change in populations, how life evolves and how society decides.',
    icon: TreeDeciduousIcon,
  },
];
